<!-- Infographics Start -->
<div class="section section-padding bg-cover bg-center bg-parallax dark-overlay dark-overlay-2" style="background-image: url('assets/img1/couverture_resto_pita.jpg')">
    <div class="container">
        <div class="section-title-wrap section-header text-center">
            <h2 class="title text-white">Notre success Story</h2>
            <p class="subtitle text-white">
                Notre restaurant familial, né de la passion et du dévouement de plusieurs générations, est devenu un pilier de notre communauté grâce à notre cuisine maison authentique et à notre service chaleureux. Nous sommes fiers de continuer à partager notre héritage culinaire avec nos clients, et nous sommes reconnaissants pour leur fidélité qui a fait de notre établissement une destination incontournable.            </p>
        </div>
        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-6" *ngFor="let item of successpost">
                <div class="ct-infographic-item">
                    <i class="{{item.icon}}"></i>
                    <h4>{{item.count | number:'1.0-0'}}</h4>
                    <p>{{item.title}}</p>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Infographics End -->